import map from '../../../node_modules/ramda/es/map.js';
import pipe from '../../../node_modules/ramda/es/pipe.js';
import differenceWith from '../../../node_modules/ramda/es/differenceWith.js';
import propEq from '../../../node_modules/ramda/es/propEq.js';

var optionComparator = function optionComparator(obj1, obj2) {
  return obj1.label === obj2.label;
};
var makeOption = function makeOption(_ref) {
  var label = _ref.label;
  return {
    value: label,
    label: label
  };
};
var makeOptions = pipe(differenceWith(optionComparator), map(makeOption));
var valueEquals = propEq("value");

export { makeOption, makeOptions, optionComparator, valueEquals };
